import React from "react";
import PropTypes from "prop-types";
import Container from "../layout/Container";
import {useTheme} from "../../theme/ThemeProvider";

const StatusIcon = ({color, sx = {}}) => {
  const {theme} = useTheme();

  return (
    <Container
      sx={{
        width: "8px",
        height: "8px",
        borderRadius: "50%",
        backgroundColor:
          theme.colors[color] || color || theme.colors.textPrimary,
        display: "inline-block",
        ...sx,
      }}
    />
  );
};

StatusIcon.propTypes = {
  color: PropTypes.string,
};

export default StatusIcon;
